import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { DealerSignUpFormComponent } from './components/form/dealer-sign-up-form.component';
import { DealerSignUpModalComponent } from './containers/dealer-sign-up-modal.component';
import { DealerSignUpConfirmationComponent } from './components/confirmation/dealer-sign-up-confirmation.component';
import { DealerSignUpService } from './services/dealer-sign-up.service';
import { DealerSignUpWaitComponent } from './components/wait/dealer-sign-up-wait.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [
    DealerSignUpFormComponent,
    DealerSignUpModalComponent,
    DealerSignUpConfirmationComponent,
    DealerSignUpWaitComponent
  ],
  providers: [HttpClientModule, DealerSignUpService]
  ,
  exports: [DealerSignUpModalComponent]
})
export class DealerSignUpModule {}



// WEBPACK FOOTER //
// ./src/app/dealer-sign-up/dealer-sign-up.module.ts